import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { PageHeader } from "@/components/ui-bits";
import { VaultList } from "@/pages/Onboarding";
import ProposalDialog from "@/components/ProposalDialog";

const TABS = [["offers", "Offer Vault"], ["proofs", "Story + Proof Vault"], ["events", "What's Coming Up"]];
const INTRO: Record<string, string> = {
  offers: "Everything you sell. Set how often each offer gets promoted and Email Bestie balances the rest.",
  proofs: "Real testimonials, wins, stories, FAQs and objections. This is the only place Email Bestie will ever pull proof from.",
  events: "Launches, sales, webinars, deadlines. When you add one, Email Bestie proposes calendar changes for you to approve.",
};

export default function Vaults() {
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "offers";
  const [items, setItems] = useState<Record<string, any[]>>({ offers: [], proofs: [], events: [] });
  const [proposal, setProposal] = useState<any>(null);
  const [busy, setBusy] = useState(false);
  const load = async () => { const [o, p, e] = await Promise.all([api.get("/offers"), api.get("/proofs"), api.get("/events")]); setItems({ offers: o.data, proofs: p.data, events: e.data }); return e.data; };
  useEffect(() => { load(); }, []);

  const onChange = async () => {
    const prevEvents = items.events.map((e) => e.id);
    const events = await load();
    const added = events.find((e: any) => !prevEvents.includes(e.id));
    if (tab === "events" && added) proposeFor(added);
  };
  const proposeFor = async (ev: any) => {
    setBusy(true);
    toast("Working out how this changes your calendar...");
    try { const { data } = await api.post("/calendar/propose", { trigger_type: "new_event", event_id: ev.id }); setProposal(data); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <div>
      <PageHeader eyebrow="Vaults" title="What Email Bestie knows about your business" subtitle="Per-account, private, and the source of truth for every email." testId="vaults-header" />
      <div className="flex gap-2 overflow-x-auto mb-6" data-testid="vault-tabs">
        {TABS.map(([k, l]) => <button key={k} onClick={() => setParams({ tab: k })} className={`rounded-full px-4 py-2 text-sm font-semibold whitespace-nowrap border transition-colors ${tab === k ? "bg-navy text-cream border-navy" : "bg-cream border-line text-ink-muted hover:border-navy/40"}`} data-testid={`vault-tab-${k}`}>{l} <span className="opacity-60">{items[k].length}</span></button>)}
      </div>
      <div className="grid lg:grid-cols-[1fr_320px] gap-6 items-start">
        <div><VaultList kind={tab} items={items[tab]} offers={items.offers} onChange={onChange} /></div>
        <aside className="card-soft p-5 text-sm text-ink-muted lg:sticky lg:top-6">
          <p className="eyebrow mb-2">{TABS.find(([k]) => k === tab)?.[1]}</p>
          <p>{INTRO[tab]}</p>
          {tab === "events" && items.events.length > 0 && <div className="mt-4 space-y-2">{items.events.map((e) => <button key={e.id} onClick={() => proposeFor(e)} disabled={busy} className="btn-ghost w-full !py-2 text-xs justify-start" data-testid={`event-propose-${e.id}`}>Re-plan around "{e.title}"</button>)}</div>}
        </aside>
      </div>
      {proposal && <ProposalDialog proposal={proposal} onClose={() => setProposal(null)} onApplied={() => {}} />}
    </div>
  );
}
